const baseButtonStyle =
  "flex items-center justify-center rounded-lg px-4 py-3 font-semibold text-white transition duration-300 ease-in-out disabled:hover:cursor-default";

export const ComponentStyles = {
  primary:
    baseButtonStyle +
    " bg-th-primary-900 text-white hover:bg-th-primary-800 focus:outline-none focus:ring-2 focus:ring-th-primary-200 disabled:bg-th-primary-800",
  secondary:
    baseButtonStyle +
    " bg-th-secondary-900 text-white hover:bg-th-secondary-800 focus:outline-none focus:ring-2 focus:ring-th-secondary-200 disabled:bg-th-secondary-400",
  accent:
    baseButtonStyle +
    " bg-th-accent-900 text-white hover:bg-th-accent-800 focus:outline-none focus:ring-2 focus:ring-th-accent-200 disabled:bg-th-accent-800",
  success:
    baseButtonStyle +
    " bg-green-900 text-white hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-green-200 disabled:bg-green-800",
  warning:
    baseButtonStyle +
    " bg-yellow-400 text-white hover:bg-yellow-300 focus:outline-none focus:ring-2 focus:ring-yellow-100 disabled:bg-yellow-300",
  error:
    baseButtonStyle +
    " bg-red-600 text-white hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-200 disabled:bg-red-400",

  primary_off:
    baseButtonStyle +
    " bg-white text-th-primary-900 border-th-primary-900 border-solid border hover:bg-th-primary-100 disabled:border-transparent disabled:bg-white/50",
  secondary_off:
    baseButtonStyle +
    " bg-white border-th-secondary-900 border-solid border hover:bg-th-secondary-100 disabled:border-transparent disabled:bg-white/50",
  accent_off:
    baseButtonStyle +
    " bg-white border-th-accent-900 border-solid border hover:bg-th-accent-100 disabled:border-transparent disabled:bg-white/50",
  success_off:
    baseButtonStyle +
    " bg-white border-th-success-900 border-solid border hover:bg-th-success-100 disabled:border-transparent disabled:bg-white/50",
  warning_off:
    baseButtonStyle +
    " bg-white border-th-warning-900 border-solid border hover:bg-th-warning-100 disabled:border-transparent disabled:bg-white/50",
  error_off:
    baseButtonStyle +
    " bg-white border-th-error-900 border-solid border hover:bg-th-error-100 disabled:border-transparent disabled:bg-white/50",
};
